var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Check(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6668 15.9999C30.6668 24.1001 24.1003 30.6666 16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325C24.1003 1.33325 30.6668 7.89974 30.6668 15.9999ZM23.5976 12.6213C24.1249 12.1072 24.1356 11.263 23.6215 10.7358C23.1074 10.2085 22.2633 10.1979 21.736 10.7119L13.7779 18.4711L10.2643 15.0453C9.73705 14.5312 8.8929 14.5419 8.37883 15.0691C7.86476 15.5964 7.87545 16.4405 8.4027 16.9546L12.8471 21.2879C13.365 21.7928 14.1909 21.7928 14.7087 21.2879L23.5976 12.6213Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Check);
export default __webpack_public_path__ + "static/media/100-check.d46ba1d4a4776d7afa7bc3f887ddd812.svg";
export { ForwardRef as ReactComponent };